import LoginLayout from '../../layouts/LoginLayout'
import Logout from './Logout'

export default LoginLayout(Logout)
